import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import withRouterHooks from 'utils/routerHelper';
import CustomInfoEdit from '../customInfoEdit';
import Edit from '../edit';

class MobileTaskEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(),
      error: {},
      isChanged: false,
      showCloseModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Task.page.loadingItem);
    this.props.dispatch(ReduxActions.task.fetch(Utils.Router.getParams().id))
      .then((res) => {
        if (!Utils.Helper.isNullOrUndefined(this.props.account.addons_setting)
          && this.props.account.addons_setting.custom_field
          && (res.task.custom_field_group || {}).id) {
          this.props.dispatch(ReduxActions.customFieldGroup.fetch(res.task.custom_field_group.id));
          this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
        }
        this.props.dispatch(ReduxActions.constant.fetchList());
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ form: this._getDefaultForm(nextProps.data) });
    }
    if (nextProps.customFieldGroups !== this.props.customFieldGroups
      && !Utils.Helper.isNullOrUndefined(nextProps.account.addons_setting)
      && nextProps.account.addons_setting.custom_field) {
      const customFieldGroupId = this.state.form.custom_field_group_id;

      this._onFormChange('custom_fields_attributes',
        this._getCustomFieldsDefaultForm(
          this.state.form.custom_fields_attributes,
          nextProps.customFieldGroups[customFieldGroupId],
        ));

      // Forcefully setState such that isChanged is false, so that during initial load,
      // user can press Esc to exit form without confirmation dialog
      this.setState({ isChanged: false });
    }
  }

  _onFormChange(fieldName, value, index, isDelete) {
    if (!this.state.isChanged) {
      this.setState({ isChanged: true });
    }

    if (fieldName === 'custom_field_group_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          custom_field_group_id: value,
          custom_fields_attributes: [],
        }),
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.customFieldGroup.fetch(value));
      }
    } else if (fieldName === 'billing_account_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          billing_account_id: value,
        }),
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
      }));
    }
  }

  _getDefaultForm(d) {
    const data = d || this.props.data || {};
    const customFieldGroupId = Utils.Helper.isNullOrUndefined(data.custom_field_group)
      ? null : data.custom_field_group.id;
    return {
      billing_account_id: data.billing_account_id
        || (data.billing_account && data.billing_account.id),
      address_attributes: this._getAddressDefaultForm(data),
      time_type: data.time_type,
      time_from: data.time_from,
      time_to: data.time_to,
      time_window_id: Utils.Helper.isNullOrUndefined(data.time_window)
        ? data.time_window_id : data.time_window.id,
      tag_list: (data.tags && data.tags.map(item => item.name)) || [],
      photos_attributes: this._getPhotosDefaultForm(data),
      epod_attachments_attributes: this._getEpodAttachmentsDefaultForm(data),
      measurements_attributes: this._getMeasurementDefaultForm(data),
      remarks: data.remarks,
      invoice_number: data.invoice_number,
      price: data.price,
      tracking_id: data.tracking_id,
      expected_cod: data.expected_cod,
      custom_field_group_id: (data.custom_field_group || {}).id, // for validation
      custom_fields_attributes:
        (this.props.account.addons_setting && this.props.account.addons_setting.custom_field)
          ? this._getCustomFieldsDefaultForm(data.custom_fields, this.props.customFieldGroups[
            customFieldGroupId]) : undefined,
    };
  }

  _getMeasurementDefaultForm = (data) => {
    const measurement = data.measurements || [];
    return measurement;
  }

  _getPhotosDefaultForm = (data) => {
    const photos = data.photos || [];
    return photos.map(photo => ({
      id: photo.id,
      name: photo.name,
      url: photo.url,
    }));
  }

  _getEpodAttachmentsDefaultForm = (data) => {
    const attachments = data.epod_attachments || [];
    return attachments.map(attachment => ({
      id: attachment.id,
      name: attachment.name,
      url: attachment.url,
    }));
  }

  _getAddressDefaultForm = (data) => {
    const address = data.address || {};
    return {
      name: address.name,
      line_1: address.line_1,
      line_2: address.line_2,
      city: address.city,
      country: address.country,
      zip: address.zip,
      contact_person: address.contact_person,
      contact_number: address.contact_number,
      email: address.email,
    };
  }

  _getCustomFieldsDefaultForm = (customFields, customFieldGroup) => {
    if (Utils.Helper.isNullOrUndefined(customFieldGroup)) {
      return [];
    }

    return customFieldGroup.custom_field_descriptions.map((item) => {
      const customField = Utils.Helper.isNullOrUndefined(customFields) ? {}
        : customFields.find((field) => {
          const id = Utils.Helper.isNullOrUndefined(field.custom_field_description)
            ? field.custom_field_description_id : field.custom_field_description.id;

          return id === item.id;
        });
      const value = (customField || {}).value;
      const subvalue = (customField || {}).subvalue;
      return {
        custom_field_description_id: item.id,
        value,
        subvalue,
        id: (customField || {}).id,
      };
    });
  }

  _renderNavBar() {
    const data = this.props.data || {};

    return (
      <Components.Mobile.NavigationBar
        leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
        menuItems={[{
          text: 'Archive',
          action: () => {},
        }, {
          text: 'Unarchive',
          action: () => {},
        }]}
        onLeftButtonClick={() => {
          if (this.state.isChanged) {
            this.setState({ showCloseModal: true });
          } else {
            this.props.navigate('/tasks');
          }
        }}
        renderRightPanel={() => (
          <Components.Button
            className="vf-measurement-edit__navbar-button"
            id="vf-mobile-task__edit-form__panel-add-item-button"
            onClick={() => {
              this._onFormChange('measurements_attributes',
                [...this.state.form.measurements_attributes, {
                  quantity: '',
                  quantity_unit: '',
                }]);
              setTimeout(() => {
                this.bottom.scrollIntoView({ behavior: 'smooth' });
              }, 200);
            }}
            showShadow={false}
          >
            <i className="versa-add" />
            <div className="vf-measurement-edit__navbar-button__text">
              {this.props.strings.Task.form.buttons.addNewItems}
            </div>
          </Components.Button>
        )}
        title={`Task ${data.job_type === 'pickup' ? 'pickup' : 'delivery'} info`}
      />
    );
  }

  _renderCustomInfo() {
    const customFieldGroupId = Utils.Helper.isNullOrUndefined(this.props.data.custom_field_group)
      ? null
      : this.props.data.custom_field_group.id;
    return (
      this.props.account.addons_setting.custom_field === addOnsSettings.subscribed
        ? (
          <div>
            <CustomInfoEdit
              customFieldGroup={this.props.customFieldGroups[customFieldGroupId]}
              data={this.props.data}
              error={this.state.error.custom_fields || []}
              form={this.state.form}
              id="vf-mobile-task__edit-form__custom-info"
              isNewTask={false}
              onFormChange={(fieldName, value, i) => this._onFormChange(fieldName, value, i)}
              options={this._getCustomFieldGroupOptions()}
              strings={this.props.strings.Task.form.customInfo}
            />
            <Components.Form.Divider size="MEDIUM" />
          </div>
        ) : false
    );
  }

  _renderButton() {
    const { form } = this.state;
    if (
      Utils.Helper.isNonEmptyString(form.address_attributes.country)
        && Utils.Helper.isNonEmptyString(form.address_attributes.line_1)
        && Utils.Helper.isNonEmptyString(form.time_from)
    ) {
      return (
        <Components.Form.MobileMainButton
          iconClassName="versa-completed"
          id="vf-mobile-task__edit-form__save-button"
          onClick={() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Task.form.saving,
            );
            this.props.dispatch(ReduxActions.task.update(this.props.data.id, {
              ...this.state.form,
              custom_field_group_id: undefined,
            }))
              .then(() => {
                this.props.navigate(`/tasks/${this.props.data.id}`);
              })
              .catch((error) => {
                this.setState({ error });
              })
              .then(() => {
                Utils.FullScreenLoading.FullScreenLoadingManager.close();
              });
          }}
        >
          {this.props.strings.Task.form.buttons.save}
        </Components.Form.MobileMainButton>
      );
    }

    return false;
  }

  render() {
    if (Utils.Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    return (
      <Components.Form.MobileCoreLayout
        className="vf-task__mobile-edit-form"
        footer={this._renderButton()}
        header={this._renderNavBar()}
      >
        <Edit
          account={this.props.account}
          constant={this.props.constant}
          customFieldGroups={this.props.customFieldGroups}
          customer={this.props.customer}
          data={this.props.data}
          error={this.state.error}
          form={this.state.form}
          id="vf-mobile-task__edit-form"
          onFormChange={(fieldName, value, index, isDelete) => {
            this._onFormChange(fieldName, value, index, isDelete);
          }}
          optionCustomFieldGroups={this.props.optionCustomFieldGroups}
        />
        <div ref={(c) => { this.bottom = c; }} />
        <Components.Form.CloseConfirmationDialog
          leftButtonOnClick={() => this.props.navigate('/tasks')}
          rightButtonOnClick={() => this.setState({ showCloseModal: false })}
          visible={this.state.showCloseModal}
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

MobileTaskEditForm.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
    }),
  }).isRequired,
  constant: PropTypes.shape({}).isRequired,
  customFieldGroups: PropTypes.shape({}).isRequired,
  customer: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    billing_account_id: PropTypes.number,
    time_type: PropTypes.string,
    time_from: PropTypes.string,
    time_to: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes,
    })),
    photos: PropTypes.arrayOf(PropTypes.shape()),
    measurements: PropTypes.arrayOf(PropTypes.shape()),
    remarks: PropTypes.string,
    invoice_number: PropTypes.string,
    price: PropTypes.number,
    tracking_id: PropTypes.string,
    expected_cod: PropTypes.number,
    custom_field_group: PropTypes.shape(),
    custom_field_group_id: PropTypes.number,
    guid: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          addNewItems: PropTypes.string,
          save: PropTypes.string,
        }),
        customInfo: PropTypes.shape(),
        saving: PropTypes.string,
      }),
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const mapStateToProps = (state) => {
  const {
    task, account, customFieldGroup, profile, constant,
  } = state;

  return {
    data: task.tasks[Utils.Router.getParams().id],
    account: account.account,
    constant: constant.constant,
    customer: profile.profile,
    customFieldGroups: customFieldGroup.customFieldGroups,
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(MobileTaskEditForm)));
